export const getSchemaByType = (schemas) => {
    if (schemas.length) {
        return schemas[0];
    }
};
